import React from "react";

function ProductGridLoading(props) {
  const { children } = props;

  return <>{children}</>;
}

export default ProductGridLoading;
